// extracted by mini-css-extract-plugin
module.exports = {"visible":"card_visible__1LkNr","invisible":"card_invisible__5U379","inner_grid":"card_inner_grid__1frIM","inner_block":"card_inner_block__dtPiE","h3":"card_h3__1fRWW"};